import FreeOpinion from "models/FreeOpinion";

export const INIT = "freeOpinionReport/INIT";
export const SET = "freeOpinionReport/SET";
export const SET_ERRORS = "freeOpinionReport/SET_ERRORS";
export const SET_EDITABLE_COMMENT = "freeOpinionReport/SET_EDITABLE_COMMENT";
export const SET_COMMENT = "freeOpinionReport/SET_COMMENT";

export const initFreeOpinionReport = () => ({
  type: INIT
});
export const setFreeOpinionReport = res => {
  const { freeOpinionList } = res;
  const data = freeOpinionList.data.map(
    v => new FreeOpinion({ ...v, initAnswer: v.answer })
  );
  return {
    type: SET,
    freeOpinionList: {
      number: freeOpinionList.number,
      title: freeOpinionList.title,
      attrTitle: freeOpinionList.attrTitle,
      data
    },
    errors: []
  };
};

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

export const setEditableComment = (id, isEdit) => ({
  type: SET_EDITABLE_COMMENT,
  id,
  isEdit
});

export const setComment = (id, answer) => ({
  type: SET_COMMENT,
  id,
  answer
});

const initialState = {
  freeOpinionList: {
    number: "",
    title: "",
    attrTitle: "",
    data: [new FreeOpinion()]
  },
  errors: []
};

const freeOpinionReport = (state = initialState, action) => {
  switch (action.type) {
    case INIT: {
      return {
        ...initialState
      };
    }
    case SET: {
      const { freeOpinionList, errors } = action;
      return {
        ...state,
        freeOpinionList,
        errors
      };
    }
    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }
    case SET_EDITABLE_COMMENT: {
      const lists = state.freeOpinionList.data.map(rec => {
        if (rec.get("id") === action.id) {
          return rec.set("isEdit", action.isEdit);
        }
        return rec;
      });
      return {
        ...state,
        freeOpinionList: {
          ...state.freeOpinionList,
          data: lists
        }
      };
    }
    case SET_COMMENT: {
      const lists = state.freeOpinionList.data.map(rec => {
        if (rec.get("id") === action.id) {
          return rec.set("answer", action.answer);
        }
        return rec;
      });
      return {
        ...state,
        freeOpinionList: {
          ...state.freeOpinionList,
          data: lists
        }
      };
    }
    default:
      return state;
  }
};

export default freeOpinionReport;



// WEBPACK FOOTER //
// ./src/redux/modules/freeOpinionReport.js